import { render, staticRenderFns } from "./VaCard.demo.vue?vue&type=template&id=93ba0cf6&scoped=true&"
import script from "./VaCard.demo.vue?vue&type=script&lang=js&"
export * from "./VaCard.demo.vue?vue&type=script&lang=js&"
import style0 from "./VaCard.demo.vue?vue&type=style&index=0&id=93ba0cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ba0cf6",
  null
  
)

export default component.exports